module.exports = __webpack_public_path__ + "static/img/logo.32e88954.png";